import { render, staticRenderFns } from "./headerBody.vue?vue&type=template&id=1132b22f&scoped=true&"
import script from "./headerBody.vue?vue&type=script&lang=js&"
export * from "./headerBody.vue?vue&type=script&lang=js&"
import style0 from "./headerBody.vue?vue&type=style&index=0&id=1132b22f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132b22f",
  null
  
)

export default component.exports